import {observable} from 'mobx';
import {construct, ModelProperties} from '../utils';

export class OfferPageCategory {
    @observable id!: number;

    @observable name!: string;

    @observable description!: string;

    @observable data?: string;

    constructor(category?: ModelProperties<OfferPageCategory>) {
        if (category) {
            construct(this, category);
        }
    }
}